import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { useState, useEffect } from 'react';
// Custom components
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReactPaginate from 'react-paginate';
import {
  allBranchDetail,
  getFollowup,
  viewLead,
  allCounselorDetail
} from '../../../redux/actions/Files.action';
import userPhoto from '../../../assets/img/user.png';
import moment from 'moment';
import { FaEdit } from 'react-icons/fa';
import { MdCampaign, MdDescription, MdWhatsapp } from 'react-icons/md';
import FileUpdate from 'views/admin/lead/FileUpdate';
import { IoSearchOutline } from 'react-icons/io5';
import { Button, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { getMessage, getSetting } from '../../../redux/actions/Setting.action';
import { FaPhone } from 'react-icons/fa6';
// import "./styles.css"
import { FaCalendarPlus, FaRegClock, FaUser } from 'react-icons/fa';
import { MdDateRange, MdDelete, MdLocationOn, MdComment } from 'react-icons/md';
import { FaWpforms } from 'react-icons/fa6';
import { FiTarget } from 'react-icons/fi';


// Add responsive styles
const responsiveStyles = `
  /* Styles for all screen sizes */
  .mobile-only-button {
    display: none !important;
  }
  
  @media only screen and (max-width: 768px) {
    .mobile-only-button {
      display: inline-flex !important;
    }
  }
`;
export default function FollowUp() {
  const [mainPage, setMainPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split('T')[0],
  );
  const [searchTerm, setSearchTerm] = useState('');
  const [updateId, setUpdateId] = useState('');
  const [updateModal, setUpdateModal] = useState(false);
  const [isWhatsappModalOpen, setIsWhatsappModalOpen] = useState(false);
  const [selectedMobileNumber, setSelectedMobileNumber] = useState('');
  const [selectedLeadName, setSelectedLeadName] = useState('');
  const [whatsappDropdownSelection, setWhatsappDropdownSelection] = useState('');
  const [whatsAppMessage, setWhatsAppMessage] = useState([]);
  const [otherMessage, setOtherMessage] = useState('');
  const [leadStatuses, setLeadStatuses] = useState([]);
  const [errors, setErrors] = useState({ dropdown: '', other: '' });
  const [searchDefault, setSearchDefault] = useState({
    page: '',
    search: '',
    startDate: '',
    endDate: '',
    status: '',
    managerId: ''  // Add managerId to searchDefault
  });

  const dispatch = useDispatch();
  const getFollowups = useSelector((state) => state.files);
  const setting = useSelector((state) => state.setting);
  const managers = getFollowups?.allCounselor?.data?.CounselorsData || [];  // Add managers from redux state


  const ChangeMainPage = (selected) => {
    setMainPage(parseInt(selected.selected) + 1);
  };

  const handleRowsPerPageChange = (e) => {
    const newRowsPerPage = parseInt(e.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setMainPage(1);
  };

  const postPerPage = rowsPerPage;
  const PageCount = Math.ceil(
    getFollowups?.getFollowup?.data?.totalPatients / postPerPage,
  );

  useEffect(() => {
    dispatch(getSetting())
  }, [])

  useEffect(() => {
    if (Array.isArray(setting?.getSetting?.leadStatuses?.leadStatuses) && setting?.getSetting?.leadStatuses?.leadStatuses.length > 0) {
      setLeadStatuses(setting.getSetting.leadStatuses?.leadStatuses || []);
    }
  }, [setting]);
  useEffect(() => {
    const queryParams = {
      page: mainPage,
      limit: rowsPerPage,
      date: selectedDate,
      search: searchTerm.trim(),
      managerId: searchDefault.managerId, // Pass managerId from searchDefault
    };
    dispatch(getFollowup(queryParams));
  }, [mainPage, rowsPerPage, selectedDate, searchTerm, searchDefault.managerId]);

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const updateToggle = (id) => {

    setUpdateModal(!updateModal);
    dispatch(viewLead(id));
    if (!updateModal) {
      setUpdateId(id);
    } else {
      setUpdateId('');
    }
  };

  const openWhatsappModal = (mobileNumber, firstName, lastName) => {
    setIsWhatsappModalOpen(true);
    setSelectedMobileNumber(mobileNumber);
    setSelectedLeadName(`${firstName} ${lastName}`);
  };

  const closeWhatsappModal = () => {
    setIsWhatsappModalOpen(false);
    setWhatsappDropdownSelection('');
    setOtherMessage('');
    setErrors({ dropdown: '', other: '' });
  };

  const handleSend = () => {
    let hasError = false;
    const newErrors = { dropdown: '', other: '' };

    if (!whatsappDropdownSelection) {
      newErrors.dropdown = 'Please select a message option.';
      hasError = true;
    }

    if (whatsappDropdownSelection === 'other' && !otherMessage.trim()) {
      newErrors.other = 'Please enter your custom message.';
      hasError = true;
    }

    setErrors(newErrors);
    if (hasError) return;

    let formattedNumber = selectedMobileNumber;
    // if (!formattedNumber.startsWith('91')) {
    //   formattedNumber = `91${formattedNumber}`;
    // }

    let messageToSend = '';
    if (whatsappDropdownSelection === 'other') {
      messageToSend = otherMessage;
      setOtherMessage('');
    } else {
      const selectedMsgObj = whatsAppMessage.find((msg) => msg._id === whatsappDropdownSelection);
      messageToSend = selectedMsgObj?.description || '';
      setOtherMessage('');
    }

    const encodedMessage = encodeURIComponent(messageToSend);
    const whatsappURL = `https://api.whatsapp.com/send?phone=${formattedNumber}&text=${encodedMessage}`;

    window.open(whatsappURL, '_blank');
    closeWhatsappModal();
  };
  const getBackgroundColor = (leadStatusName) => {
    const status = leadStatuses.find(status =>
      status.title.toLowerCase() === leadStatusName.toLowerCase()
    );

    return status ? status.backgroundColor : "transparent";
  };
  useEffect(() => {
    dispatch(getMessage())
      .then((res) => {
        if (res?.status === 200) {
          setWhatsAppMessage(res?.data?.data || []);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);
  const formatTime = (dateString) => {
    const date = new Date(dateString);
    let hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12;
    hours = hours || 12;
    const minutesFormatted = minutes < 10 ? '0' + minutes : minutes;

    return `${hours}:${minutesFormatted} ${ampm}`;
  };
  const handlePhoneClick = (phoneNumber) => {
    window.location.href = `tel:${phoneNumber}`;
  };
  const handleManagerChange = (e) => {
    const managerId = e.target.value;
    setSearchDefault(prev => ({
      ...prev,
      managerId: managerId
    }));
  };
  return (
    <>
      <style>{responsiveStyles}</style>
      <div className="mt-[100px]">
        <div className="d-flex justify-between items-center gap-3">
          <div className="">
            <label className="text-sm">Select Date</label>
            <input
              type="date"
              name="startDate"
              value={selectedDate}
              onChange={handleDateChange}
              className="w-75 outline-none !border-b"
            />
          </div>
          {/* Add Manager Filter */}
          {localStorage.getItem('type') !== 'Manager' && (
            <div className="">
              <label className="text-sm block mb-1">Manager</label>
              <select
                onChange={handleManagerChange}
                value={searchDefault.managerId || ''}
                className='w-100 border-b outline-none bg-transparent'
              >
                <option value="">Select Manager</option>
                {managers.map((manager) => (
                  <option key={manager._id} value={manager._id}>{manager.name}</option>
                ))}
              </select>
            </div>
          )}
          <div className="bg-white shadow-shadows py-[8px] px-[20px] rounded-full flex items-center gap-2 me-2 ms-auto">
            <IoSearchOutline />
            <input
              type="text"
              name="search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full outline-none"
              placeholder="Search..."
            />
          </div>
        </div>
      </div>


    <div className="mt-[50px] mb-4">
  {/* Header */}
  <div className="d-flex flex-column flex-lg-row mb-4 gap-2 gap-lg-0 align-items-stretch align-items-lg-center">
    <h2 className="mb-0 fw-bold">Today Followup</h2>
    <div className="ms-lg-auto border-r pe-3 me-3">
      Total Records:{' '}
      <span className="text-success border-b border-success">
        {getFollowups?.getFollowup?.data?.totalPatients || 0}
      </span>
    </div>
    <div className="d-flex align-items-center gap-2">
      Rows per page:
      <select
        value={rowsPerPage}
        onChange={handleRowsPerPageChange}
        className="ms-2 border rounded-md focus:outline-none"
      >
        <option value={10}>10</option>
        <option value={30}>30</option>
        <option value={50}>50</option>
        <option value={100}>100</option>
        <option value={500}>500</option>
      </select>
    </div>
  </div>

  {/* Table Format */}
  <div className="overflow-x-auto bg-white rounded-xl shadow-lg border border-gray-100">
    <table className="w-full text-left border-collapse table-auto">
      <thead>
        <tr className="bg-gray-50 border-b border-gray-200 text-gray-600 text-xs uppercase font-bold tracking-wider">
          <th className="py-3 px-4">Name</th>
          <th className="py-3 px-4">Phone</th>
          <th className="py-3 px-4">Lead Status</th>
          <th className="py-3 px-4">Follow-Up Date & Time</th>
          <th className="py-3 px-4">Lead From / Received</th>
          <th className="py-3 px-4">Location / Branch</th>
          <th className="py-3 px-4">Assignee & Remarks</th>
          <th className="py-3 px-4 text-center">Actions</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-100 text-sm">
        {getFollowups?.getFollowup?.data?.data?.length > 0 ? (
          getFollowups.getFollowup.data.data.map((res) => (
            <tr key={res._id} className="hover:bg-blue-50/40 transition-colors">
              {/* Name */}
              <td className="py-3 px-4 font-semibold text-blue-900">
                <div className="flex items-center gap-2.5">
                  <img
                    src={res.photo || userPhoto}
                    alt="avatar"
                    className="w-8 h-8 rounded-full object-cover border border-gray-200 shadow-sm"
                    onError={(e) => { e.target.onerror = null; e.target.src = userPhoto; }}
                  />
                  <span>{res.firstName} {res.lastName}</span>
                </div>
              </td>
              {/* Phone */}
              <td className="py-3 px-4 text-gray-700">
                <div className="flex items-center gap-1">
                  <FaPhone className="text-blue-500 text-xs" />
                  <span>{res.phoneNumber}</span>
                </div>
              </td>
              {/* Lead Status */}
              <td className="py-3 px-4">
                <span
                  className="inline-block px-2.5 py-1 rounded-full text-xs font-semibold text-white shadow-sm"
                  style={{
                    background: res.leadStatus
                      ? getBackgroundColor(res.leadStatus.trim().toLowerCase())
                      : 'gray',
                  }}
                >
                  {res.leadStatus || 'N/A'}
                </span>
              </td>
              {/* Follow-Up Date & Time */}
              <td className="py-3 px-4 text-gray-600">
                <div>
                  <span className="font-medium text-gray-800">
                    {res.nextFollowUpDate ? moment(res.nextFollowUpDate).format('DD/MM/YYYY') : '-'}
                  </span>
                </div>
                {res.from && (
                  <div className="text-xs text-gray-500 flex items-center gap-1 mt-0.5">
                    <FaRegClock className="text-orange-400" />
                    <span>{formatTime(res.from)}</span>
                  </div>
                )}
              </td>
              {/* Lead From / Received */}
              <td className="py-3 px-4 text-gray-600">
                <div className="text-xs font-medium text-gray-800">{res.leadFrom || 'N/A'}</div>
                <div className="text-xs text-gray-400">{res.leadReceived || ''}</div>
              </td>
              {/* Location / Branch */}
              <td className="py-3 px-4 text-gray-600">
                <div>{res.city}{res.country ? `, ${res.country}` : ''}</div>
                {res.branch && <div className="text-xs text-blue-600 font-medium">{res.branch}</div>}
              </td>
              {/* Assignee & Remarks */}
              <td className="py-3 px-4 text-gray-600 max-w-[240px]">
                {res?.counselorAssign?.name && (
                  <div className="text-xs font-semibold text-emerald-700 mb-1">
                    Assign: {res.counselorAssign.name}
                  </div>
                )}
                <div className="text-xs mb-1" title={res.remark}>
                  <strong className="text-gray-700">Lead Remark:</strong> {res.remark || 'N/A'}
                </div>
                <div className="text-xs" title={res.leadFollowUpRemark}>
                  <strong className="text-gray-700">Follow-Up Remark:</strong> {res.leadFollowUpRemark || 'N/A'}
                </div>
              </td>
              {/* Actions */}
              <td className="py-3 px-4 text-center">
                <div className="flex items-center justify-center gap-3">
                  <button
                    className="text-green-500 hover:text-green-700 transition-transform hover:scale-110"
                    onClick={() => openWhatsappModal(res.phoneNumber, res.firstName, res.lastName)}
                    title="WhatsApp"
                  >
                    <MdWhatsapp size={19} />
                  </button>
                  <button
                    className="text-blue-600 hover:text-blue-800 transition-transform hover:scale-110"
                    onClick={() => updateToggle(res)}
                    title="Edit"
                  >
                    <FaEdit size={19} />
                  </button>
                  <button
                    className="text-indigo-500 hover:text-indigo-700 transition-transform hover:scale-110"
                    onClick={() => handlePhoneClick(res.phoneNumber)}
                    title="Call"
                  >
                    <FaPhone size={17} />
                  </button>
                </div>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="8" className="text-center py-6 text-gray-500 font-medium">
              Today no any followup
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
</div>




      <ReactPaginate
        breakLabel="..."
        nextLabel="next >"
        onPageChange={ChangeMainPage}
        pageRangeDisplayed={5}
        pageCount={PageCount}
        previousLabel="< previous"
        renderOnZeroPageCount={null}
        className="pagination"
      />
      <FileUpdate
        updateModal={updateModal}
        updateToggle={updateToggle}
        updateId={updateId}
        searchDefault1={searchDefault}
      />

      <Modal show={isWhatsappModalOpen} onHide={closeWhatsappModal}>
        <Modal.Header closeButton>
          <Modal.Title>Send WhatsApp Message</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <div className="mb-4">
              <Form.Label className="fw-bold text-dark">Lead Name</Form.Label>
              <Form.Control
                type="text"
                readOnly
                disabled
                value={selectedLeadName}
                className="bg-light border-0 fw-bold text-dark"
                style={{ fontSize: '1.1rem' }}
              />
            </div>

            <div className="mb-4">
              <Form.Label className="fw-bold text-dark">Mobile Number</Form.Label>
              <Form.Control
                type="text"
                readOnly
                disabled
                value={selectedMobileNumber}
                className="bg-light border-0 fw-bold text-dark"
                style={{ fontSize: '1.1rem' }}
              />
            </div>

            <div className="mb-4">
              <Form.Label className="fw-bold text-dark">Select Message</Form.Label>
              <Form.Select
                className="border-2"
                value={whatsappDropdownSelection}
                onChange={(e) => {
                  setWhatsappDropdownSelection(e.target.value);
                  setErrors((prev) => ({ ...prev, dropdown: '' }));
                }}
              >
                <option value="">Select Option</option>
                {whatsAppMessage.map((msg) => (
                  <option key={msg._id} value={msg._id}>
                    {msg.title}
                  </option>
                ))}
                <option value="other">Other</option>
              </Form.Select>
              {errors.dropdown && (
                <div className="text-danger mt-1" style={{ fontSize: '0.875rem' }}>{errors.dropdown}</div>
              )}
            </div>

            {whatsappDropdownSelection === 'other' && (
              <div className="mb-4">
                <Form.Control
                  type="text"
                  placeholder="Please specify"
                  className="border-2"
                  value={otherMessage}
                  onChange={(e) => {
                    setOtherMessage(e.target.value);
                    setErrors((prev) => ({ ...prev, other: '' }));
                  }}
                />
                {errors.other && (
                  <div className="text-danger mt-1" style={{ fontSize: '0.875rem' }}>{errors.other}</div>
                )}
              </div>
            )}
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={closeWhatsappModal}>
            Cancel
          </Button>
          <Button
            className="!bg-theme-dark border-0 px-4"
            onClick={handleSend}
          >
            Send
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
